import { render, staticRenderFns } from "./TagCheckList.vue?vue&type=template&id=5f79e6b5&scoped=true"
import script from "./TagCheckList.vue?vue&type=script&lang=ts"
export * from "./TagCheckList.vue?vue&type=script&lang=ts"
import style0 from "./TagCheckList.vue?vue&type=style&index=0&id=5f79e6b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f79e6b5",
  null
  
)

export default component.exports